import emailjs from "@emailjs/browser";

// EmailJS configuration
const EMAILJS_CONFIG = {
  serviceId: "service_fwvy32o",
  templateId: "template_ntj43ks",
  publicKey: "AEZnAjb2ex2j6eIIt",
};

/**
 * Sends demo request email using EmailJS
 * @param {Object} formData - Form data containing name, email, phone, company
 * @returns {Promise} - EmailJS response
 */
export const sendDemoRequest = async (formData) => {
  try {
    // Initialize EmailJS with public key
    emailjs.init(EMAILJS_CONFIG.publicKey);

    // Prepare template parameters
    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      phone: formData.phone,
      company: formData.company,
      to_email: "bilgi@atiksoft.com", // Your email
      reply_to: formData.email,
      message: `
Yeni Demo Talebi

Ad Soyad: ${formData.name}
E-posta: ${formData.email}
Telefon: ${formData.phone}
Şirket: ${formData.company}

Tarih: ${new Date().toLocaleString("tr-TR")}
      `,
    };

    // Send email
    const response = await emailjs.send(
      EMAILJS_CONFIG.serviceId,
      EMAILJS_CONFIG.templateId,
      templateParams,
    );

    console.log("Email sent successfully:", response);
    return { success: true, response };
  } catch (error) {
    console.error("Email send error:", error);
    return { success: false, error };
  }
};

export const sendContactMessage = async (formData) => {
  try {
    emailjs.init(EMAILJS_CONFIG.publicKey);
    const templateParams = {
      from_name: `${formData.firstName} ${formData.lastName}`.trim(),
      from_email: formData.email,
      phone: formData.phone,
      company: formData.company,
      subject: formData.subject,
      to_email: "bilgi@atiksoft.com",
      reply_to: formData.email,
      message: `İletişim Formu\n\nAd Soyad: ${formData.firstName} ${formData.lastName}\nE-posta: ${formData.email}\nTelefon: ${formData.phone}\nKurum: ${formData.company}\nKonu: ${formData.subject}\n\nMesaj:\n${formData.message}`,
    };
    const response = await emailjs.send(
      EMAILJS_CONFIG.serviceId,
      EMAILJS_CONFIG.templateId,
      templateParams,
    );
    return { success: true, response };
  } catch (error) {
    console.error("Contact form email error:", error);
    return { success: false, error };
  }
};

/**
 * Validates EmailJS configuration
 * @returns {boolean} - True if config is valid
 */
export const isEmailConfigured = () => {
  return (
    EMAILJS_CONFIG.serviceId !== "service_xxxxxxx" &&
    EMAILJS_CONFIG.templateId !== "template_xxxxxxx" &&
    EMAILJS_CONFIG.publicKey !== "xxxxxxxxxxxxxxx"
  );
};
